const obj = {
  server: {
    api: "https://api-prod.warriortrading.com/api",
    stock: "https://scan-prod.warriortrading.com",
    identity: "https://identity-prod.warriortrading.com/security",
    chatroom: "https://chatroom.warriortrading.com",
    sim: "https://sim-prod.warriortrading.com",
  },
  scannerServers: [
    {
      name: "scan-qa",
      value: "https://scan-qa.warriortrading.com",
      down: "https://scan-qa.warriortrading.com/ops-api/v1/down-hpas",
      up: "https://scan-qa.warriortrading.com/ops-api/v1/up-hpas",
    },
    {
      name: "scan-prod",
      value: "https://scan-prod.warriortrading.com",
      down: "",
      up: "",
    },
  ],
};

export default obj;
